'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('../../node_modules/react/jsx-runtime.js');
var MtCaptcha = require('./providers/MtCaptcha.js');
var HCaptcha = require('./providers/HCaptcha.js');

const Captcha = (props) => {
    return jsxRuntime.jsxRuntimeExports.jsxs("div", { children: [props.siteKey && props.providerName === 'MTCAPTCHA' && jsxRuntime.jsxRuntimeExports.jsx(MtCaptcha.default, { siteKey: props.siteKey, language: props.language.toLowerCase(), onVerified: props.onVerified }), props.siteKey && props.providerName === 'HCAPTCHA' && jsxRuntime.jsxRuntimeExports.jsx(HCaptcha.default, { siteKey: props.siteKey, language: props.language.toLowerCase(), onVerified: props.onVerified })] });
};

exports.default = Captcha;
//# sourceMappingURL=Captcha.js.map
